export default "__VITE_ASSET__DkQwAFI4__";